interface IIP {
  requires<M>(s: string[]): Promise<M[]>;
}

interface IWindowSGDDesktop extends Window {
  $ip: IIP;
}

declare var window: IWindowSGDDesktop;

interface AIProductAPI {
  use_greeting: boolean;
  greeting: string;
}

export function addSubscribers(hostMicro) {
  hostMicro
    .on('initialize', () => {})
    .on('activate', () => {})
    .on('mount', () => {});

  hostMicro.subscribe('enter -> /micro/survey-home', async (parameters) => {
    window.location.assign('#/my/host/survey-home/list');
  });

  // load knowledge bot when we go to kbi
  //
  //
  hostMicro.subscribe('on_enter -> /kbi', async (parameters) => {
    const $ip = window['$ip'] as IIP;

    // wait for knowledge bot
    //
    await ($ip as any).$loader.loadCrate('@eab-nav/knowledge-bot', 'local');

    const navAIOptions = (endpoint_uri: string, endpoint_uri_split_string: string) => ({
      authorization: {
        type: 'ctm'
      },
      servers: {
        ctm: {
          endpoint_uri,
          endpoint_uri_headers: {},
          endpoint_token_headers: {},
          endpoint_token: `/api/v1/core/client_jwt/`,
          endpoint_token_response_ptr: '/access_token',
          endpoint_uri_response_ptr: '/access_url',
          endpoint_uri_split_string
        }
      }
    });

    // load HI/F tools
    //
    $ip.requires(['@eab-pip/pi-f1', '@eab-pip/pi-io']).then(([f1, io]: [any, any]) => {
      // after load of element we need to send message to bot
      //
      setTimeout(() => {
        const $ip = window['$ip'] as IIP;
        const baseURI = (localStorage.getItem('NetworkConfiguration') || '').trim().replace(/"/g, '');

        new Promise((resolve) => {
          // load the title of the knowledge bot
          //
          //
          io.create('api')
            .include('api/hosting')
            .intercept(io.fn.api.request.ctm)
            .options(navAIOptions(`/api/v1/core/retrieve_endpoint/?service_key=navai&endpoint_name=products`, "/split"))
            .intercept({
              type: 'request',
              async invoke(infoIO) {
                infoIO.uri = `${infoIO.uri.replace('/products/split', '')}/products/1`;
                return infoIO;
              }
            })
            .invoke('')
            .then((response) => {
              if (!response.data) {
                return resolve({});
              }

              const kbiEl = document.querySelector('eab-nav-knowledge-bot') as any;
              if (!kbiEl) {
                return resolve({});
              }

              // only if there is a name should we update
              //
              if (response.data.name) {
                kbiEl.heading = response.data.name;
              }

              return resolve(response.data);
            });
        }).then((product: Partial<AIProductAPI>) => {
          //
          //
          //
          io.create('api')
            .include('api/hosting')
            .intercept(io.fn.api.request.ctm)
            .options(navAIOptions(`/api/v1/core/retrieve_endpoint/?service_key=navai&endpoint_name=legal_notice`, '?'))
            .invoke('')
            .then((response) => {
              if (!response.data) {
                return;
              }

              const kbiEl = document.querySelector('eab-nav-knowledge-bot') as any;
              if (!kbiEl) {
                return;
              }

              kbiEl.prompts = kbiEl.prompts || ([] as { html: string }[]);

              if (response.data.notice) {
                kbiEl.prompts.push({ html: response.data.notice });
              }
              if (product.use_greeting && product.greeting) {
                kbiEl.prompts.push({ html: product.greeting });
              } else if (!product.use_greeting) {
                kbiEl.prompts.push({ html: "Hello! I am a knowledge bot here to answer student questions. How can I help you today?" });
              }
            });
        });

        // load the image for the knowledge bot
        //
        //
        io.create('null')
          .include('api/hosting')
          .intercept(io.fn.api.request.ctm)
          .options(navAIOptions(`/api/v1/core/retrieve_endpoint/?service_key=navai&endpoint_name=products`, "/split"))
          .intercept({
            type: 'request',
            async invoke(infoIO) {
              try {
                const request = f1.merge(
                  'over',
                  {
                    method: 'GET',
                    referrerPolicy: 'origin-when-cross-origin',
                    credentials: 'same-origin',
                    cache: 'default',
                    redirect: 'follow',
                    mode: 'cors'
                  },
                  infoIO.packet
                );

                infoIO.uri = `${infoIO.uri.replace('/products/split', '')}/products/1/image`;

                const kbiEl = document.querySelector('eab-nav-knowledge-bot') as any;
                const response = await fetch(infoIO.uri, request);
                const content = await response.blob();

                try {
                  const blobUri = URL.createObjectURL(content);

                  if (kbiEl && blobUri) {
                    kbiEl.image = blobUri;
                  }
                } catch {}

                return {
                  metadata: {},
                  data: null,
                  response
                };
              } catch (e) {
                return infoIO;
              }
            }
          })
          .invoke('');

        // load the context for the knowledge bot
        //
        //
        io.create('api')
          .include('api/hosting')
          .invoke('/api/v1/core/knowledge_bot_context/')
          .then((_) => {
            const kbiEl = document.querySelector('eab-nav-knowledge-bot') as any;
            if (!kbiEl) {
              return;
            }

            const message = f1.read('/data', {}, _);

            // send object to knowledge bot
            //
            kbiEl.bot.startup().then(() => {
              kbiEl.bot.shareWith(message);
            });

            kbiEl.bot.pointCut.add('after', 'reset', (arg) => {
              kbiEl.bot.shareWith(message);
              return arg;
            });
          });
      }, 250);
    });
  });

  return hostMicro;
}



// WEBPACK FOOTER //
// ./app/lib/host/services/subscribers.ts